module.exports = new __parcel__URL__("fullname.90161b33.png").toString();